import { render, staticRenderFns } from "./CompanyEditDesign.vue?vue&type=template&id=4bdda4d3&scoped=true&"
import script from "./CompanyEditDesign.vue?vue&type=script&lang=js&"
export * from "./CompanyEditDesign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdda4d3",
  null
  
)

export default component.exports